import { render } from "./AdminNavBar.vue?vue&type=template&id=4c5661ce"
import script from "./AdminNavBar.vue?vue&type=script&lang=js"
export * from "./AdminNavBar.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__